(() => {
  const desktop = window.matchMedia('(min-width: 701px)');
  const initialize = () => {
    document.querySelectorAll('[data-hm-footer-navigation]').forEach(navigation => {
      if (navigation.dataset.footerReady) return;
      navigation.dataset.footerReady = 'true';
      const sections = navigation.querySelectorAll('details');
      const synchronize = () => sections.forEach(section => { section.open = desktop.matches; });
      synchronize();
      desktop.addEventListener('change', synchronize);
      navigation.addEventListener('click', event => {
        if (desktop.matches && event.target.closest('summary')) event.preventDefault();
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

// HMStore: reopen the active Cookiebot consent manager from the footer.
document.addEventListener('click', function(event) {
  const link = event.target.closest('a[href="#shopifyReshowConsentBanner"]');
  if (!link || !window.Cookiebot || typeof window.Cookiebot.renew !== 'function') return;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.Cookiebot.renew();
}, true);

(() => {
  const addCookieLink = () => {
    const nav = document.querySelector('footer nav[aria-label="Acquista con fiducia"]');
    if (!nav || nav.querySelector('a[href="#shopifyReshowConsentBanner"]')) return;
    const link = document.createElement('a');
    link.href = '#shopifyReshowConsentBanner';
    link.textContent = 'Preferenze cookie';
    nav.appendChild(link);
  };
  addCookieLink();
  document.addEventListener('DOMContentLoaded', addCookieLink);
  document.addEventListener('shopify:section:load', addCookieLink);
})();
